<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="1000" scrollable>
      <v-card>
        <v-toolbar dark dense>
          <v-toolbar-title class="headline"
            >Edit daily close/open & pre order</v-toolbar-title
          >
          <v-spacer />
          <v-icon @click="closeDialog()">close</v-icon>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-layout row wrap>
            <!-- Daily -->
            <v-flex xs12 md6 class="pl-4">
              <strong class="pl-2">Daily Close/Open</strong>
              <section id="subsec01" v-for="item in timeItems" :key="item.days">
                <v-layout row justify-start>
                  <v-flex xs1 style="margin-top:20px;text-align:center;">
                    <span>{{ item.days }}</span>
                  </v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <vue-timepicker
                      v-model="item.start_time"
                      format="HH:mm"
                      :minute-interval="15"
                      class="timePicker inner-timepicker1"
                      v-if="dialog == true"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex xs1 style="margin-top:20px;text-align:center;">
                    <span>to</span>
                  </v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <vue-timepicker
                      v-if="dialog == true"
                      v-model="item.end_time"
                      :format="'HH:mm'"
                      :minute-interval="15"
                      class="timePicker inner-timepicker1"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex xs1>
                    <v-icon
                      large
                      class="mt-3"
                      color="green"
                      @click="item.more = true"
                      >add_box</v-icon
                    >
                  </v-flex>
                </v-layout>
                <v-layout row justify-start v-if="item.more == true">
                  <v-flex xs1></v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <vue-timepicker
                      v-if="dialog == true"
                      v-model="item.start_time2"
                      format="HH:mm"
                      :minute-interval="15"
                      class="timePicker inner-timepicker1"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex xs1 style="margin-top:20px;text-align:center;">
                    <span>to</span>
                  </v-flex>
                  <v-flex xs4 class="text-xs-center">
                    <vue-timepicker
                      v-if="dialog == true"
                      v-model="item.end_time2"
                      format="HH:mm"
                      :minute-interval="15"
                      class="timePicker inner-timepicker1"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex xs1>
                    <v-icon
                      large
                      class="mt-3"
                      color="red"
                      @click="indeterminate(item)"
                      >indeterminate_check_box</v-icon
                    >
                  </v-flex>
                </v-layout>
              </section>
            </v-flex>
            <!-- End-Daily -->
            <!-- Special -->
            <v-flex xs12 md6 class="pl-4">
              <div>
                <br class="hidden-md-and-up" />
                <strong class="pl-2">Pre Order</strong>
                <v-layout row justify-center>
                  <v-flex xs4>
                    <v-radio-group
                      v-model="store_preorder.preOrderGroup"
                      class="pl-2"
                    >
                      <v-radio
                        color="black"
                        label="No"
                        value="0"
                        style="margin-bottom:21px;"
                      ></v-radio>
                      <v-radio
                        color="black"
                        label="Delivery in"
                        value="1"
                        style="margin-bottom:21px;"
                      ></v-radio>
                      <v-radio
                        color="black"
                        label="Delivery in"
                        value="2"
                        style="margin-bottom:21px;"
                      ></v-radio>
                      <v-radio
                        color="black"
                        label="Delivery at"
                        value="3"
                        style="margin-bottom:21px;"
                      ></v-radio>
                      <div
                        style="padding-left:80px;padding-top:10px;color: rgba(0,0,0,.54);"
                      >
                        and
                      </div>
                      <div
                        style="padding-left:80px;padding-top:25px;color: rgba(0,0,0,.54);"
                      >
                        and
                      </div>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs4>
                    <div style="margin-bottom:45px;"></div>
                    <vue-timepicker
                      v-model="store_preorder.store_time_preorder_time"
                      format="HH:mm"
                      v-if="dialog == true"
                      :minute-interval="15"
                      class="timePicker inner-timepicker1"
                    ></vue-timepicker>
                    <v-select
                      outline
                      :items="number"
                      v-model="store_preorder.store_time_preorder_day"
                      menu-props="auto"
                      placeholder="Select date"
                      hide-details
                      style="margin-top:15px;width:130px"
                    ></v-select>
                    <v-select
                      outline
                      :items="days"
                      v-model="store_preorder.store_time_preorder_daytime[0]"
                      menu-props="auto"
                      placeholder="Select day"
                      hide-details
                      style="margin-top:15px;width:130px"
                    ></v-select>
                    <v-select
                      outline
                      :items="days"
                      v-model="store_preorder.store_time_preorder_daytime[1]"
                      menu-props="auto"
                      placeholder="Select day"
                      hide-details
                      style="margin-top:15px;width:130px"
                    ></v-select>
                    <v-select
                      outline
                      :items="days"
                      v-model="store_preorder.store_time_preorder_daytime[2]"
                      menu-props="auto"
                      placeholder="Select day"
                      hide-details
                      style="margin-top:15px;width:130px"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <div style="margin-bottom:45px;"></div>
                    <div style="padding-top:22px;color: rgba(0,0,0,.54);">
                      Hour
                    </div>
                    <div style="padding-top:27px;color: rgba(0,0,0,.54);">
                      Day
                    </div>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <v-divider class="mt-5"></v-divider>
          <v-flex class="text-xs-right">
            <v-btn color="red" flat @click="closeDialog()">cancel</v-btn>
            <v-btn
              color="green"
              :disabled="isEditStoreList"
              flat
              @click="save()"
              >save</v-btn
            >
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "timeItems", "store_preorder"],
  components: {
    VueTimepicker,
  },
  data() {
    return {
      day: null,
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      num: null,
      number: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  computed: {
    ...mapState({
      store_detail: (state) => state.fetchStoreBack.store_detail,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    closeDialog() {
      this.$emit("setDialog", false);
    },
    indeterminate(item) {
      item.more = false;
      item.end_time2 = {
        HH: "",
        mm: "",
        ss: "",
      };
      item.start_time2 = {
        HH: "",
        mm: "",
        ss: "",
      };
    },
    setEditForm() {
      let form = {
        store_time_id: null,
        store_time_open_mon: null,
        store_time_open_tue: null,
        store_time_open_wed: null,
        store_time_open_thu: null,
        store_time_open_fri: null,
        store_time_open_sat: null,
        store_time_open_sun: null,
        store_time_close_mon: null,
        store_time_close_tue: null,
        store_time_close_wed: null,
        store_time_close_thu: null,
        store_time_close_fri: null,
        store_time_close_sat: null,
        store_time_close_sun: null,
        store_time_open_mon2: null,
        store_time_open_tue2: null,
        store_time_open_wed2: null,
        store_time_open_thu2: null,
        store_time_open_fri2: null,
        store_time_open_sat2: null,
        store_time_open_sun2: null,
        store_time_close_mon2: null,
        store_time_close_tue2: null,
        store_time_close_wed2: null,
        store_time_close_thu2: null,
        store_time_close_fri2: null,
        store_time_close_sat2: null,
        store_time_close_sun2: null,
        store_time_preorder_time: null,
        store_time_preorder_day: null,
        store_time_preorder_daytime: null,
        store_time_store_id: null,
      };
      return form;
    },
    takeTime(form) {
      for (let key in this.timeItems) {
        if (
          this.timeItems[key].start_time.HH != "" &&
          this.timeItems[key].start_time.mm != "" &&
          this.timeItems[key].end_time.HH != "" &&
          this.timeItems[key].end_time.mm != ""
        ) {
          form["store_time_open_" + this.timeItems[key].days.toLowerCase()] =
            this.timeItems[key].start_time.HH +
            ":" +
            this.timeItems[key].start_time.mm +
            ":00";
          form["store_time_close_" + this.timeItems[key].days.toLowerCase()] =
            this.timeItems[key].end_time.HH +
            ":" +
            this.timeItems[key].end_time.mm +
            ":00";
        } else {
          form[
            "store_time_open_" + this.timeItems[key].days.toLowerCase()
          ] = null;
          form[
            "store_time_close_" + this.timeItems[key].days.toLowerCase()
          ] = null;
        }
        if (
          this.timeItems[key].start_time2.HH != "" &&
          this.timeItems[key].start_time2.mm != "" &&
          this.timeItems[key].end_time2.HH != "" &&
          this.timeItems[key].end_time2.mm != ""
        ) {
          form[
            "store_time_open_" + this.timeItems[key].days.toLowerCase() + "2"
          ] =
            this.timeItems[key].start_time2.HH +
            ":" +
            this.timeItems[key].start_time2.mm +
            ":00";
          form[
            "store_time_close_" + this.timeItems[key].days.toLowerCase() + "2"
          ] =
            this.timeItems[key].end_time2.HH +
            ":" +
            this.timeItems[key].end_time2.mm +
            ":00";
        } else {
          form[
            "store_time_open_" + this.timeItems[key].days.toLowerCase() + "2"
          ] = null;
          form[
            "store_time_close_" + this.timeItems[key].days.toLowerCase() + "2"
          ] = null;
        }
      }
      return form;
    },
    takePreorder(form) {
      if (this.store_preorder.preOrderGroup == 1) {
        form.store_time_preorder_time =
          this.store_preorder.store_time_preorder_time.HH +
          ":" +
          this.store_preorder.store_time_preorder_time.mm +
          ":ss";
      } else if (this.store_preorder.preOrderGroup == 2) {
        form.store_time_preorder_day = this.store_preorder.store_time_preorder_day;
      } else if (this.store_preorder.preOrderGroup == 3) {
        form.store_time_preorder_daytime = [];
        for (let key in this.store_preorder.store_time_preorder_daytime) {
          form.store_time_preorder_daytime.push(
            this.store_preorder.store_time_preorder_daytime[key]
          );
        }
      }
      return form;
    },
    validateTime(form) {
      let count_match = 0;
      let count_open = [];
      let count_close = [];
      for (let val in form) {
        if (val.split("_")[2] == "open" && form[val] != null) {
          count_open.push(val.split("_")[3]);
        }
        if (val.split("_")[2] == "close" && form[val] != null) {
          count_close.push(val.split("_")[3]);
        }
      }
      for (let val of count_open) {
        for (let val2 of count_close) {
          if (val == val2) {
            count_match++;
          }
        }
      }
      if (
        count_match == 0 ||
        count_open.length != count_match ||
        count_close.length != count_match
      ) {
        return false;
      } else {
        return true;
      }
    },
    save() {
      let form = this.setEditForm();
      form.store_time_id = this.store_detail.store_time.store_time_id;
      // form.store_time_id = 1
      form.store_time_store_id = this.store_detail.store.store_id;
      form = this.takeTime(form);
      if (!this.validateTime(form))
        return alert(
          "กรุณากรอกเวลาเปิด - ปิดร้านอย่างน้อย 1 ช่วงเวลา หรือ ช่วงเวลาไม่ครบถ้วน"
        );
      form = this.takePreorder(form);
      this.$store.dispatch("fetchStoreBack/editDailyAndPre", form);
      this.$emit("setDialog", false);
    },
  },
};
</script>
<style scoped>
.time-picker .clear-btn {
  right: 5px;
  width: 1.5em;
}
.time-picker input.display-time {
  border: none;
}
.inner-timepicker1 {
  border: 1px solid #d2d2d2;
  width: auto;
}
.inner-timepicker1:hover {
  border: 1px solid #333;
}
</style>
